export const chapterStudioPageConstant = {
    PAGE_TITLE: 'Chapter Studio',
    TITLE_FAVORITE: 'Favorites',
    READ_MORE: 'Read More',
    CLOSE: 'Close',
    ANNOUNCEMENT_TITLE_GENERAL: 'General',
    ANNOUNCEMENT_TITLE_WARNING: 'Warning',
    VISIT_NOW: 'VISIT NOW',
    DEFAULT_BACKGROUND_COLOR: '#4F90C4',
};
